import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { classNames } from '~/utils';

export const DropdownMenuItem = forwardRef<HTMLDivElement, RadixDropdownMenu.DropdownMenuItemProps>(
  ({ className, ...props }, forwardedRef) => {
    // No highlight by default: some items are just a row holding a control, and tinting one would
    // invite a click that does nothing. Selectable items opt in with `data-[highlighted]:`.
    const classes = classNames(
      'body-200-light px-4 py-[6px] text-neutral-1000 focus-visible:outline-hidden',
      className,
    );

    return <RadixDropdownMenu.Item className={classes} ref={forwardedRef} {...props} />;
  },
);
